var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVpn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vpn_svg__cls-1{fill:#669df6}.vpn_svg__cls-2{fill:#4285f4}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "vpn_svg__cls-1",
    d: "M14.73 11.28h4.18v1.38h-4.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vpn_svg__cls-1",
    d: "M17.95 6.12h1.38v11.71h-1.38z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vpn_svg__cls-2",
    x: 16.3,
    y: 17.32,
    width: 4.68,
    height: 4.68,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vpn_svg__cls-2",
    x: 16.3,
    y: 2,
    width: 4.68,
    height: 4.68,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "vpn_svg__cls-1",
    d: "M6.98 11.28h4.28v1.38H6.98z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vpn_svg__cls-2",
    x: 3.03,
    y: 9.63,
    width: 4.68,
    height: 4.68,
    rx: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "vpn_svg__cls-2",
    d: "M13 14.17a2.2 2.2 0 112.2-2.2 2.19 2.19 0 01-2.2 2.2zm0-3.57a1.38 1.38 0 101.33 1.4A1.37 1.37 0 0013 10.6z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM2NjlkZjY7fS5jbHMtMntmaWxsOiM0Mjg1ZjQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5JY29uXzI0cHhfVlBOLTAxX0NvbG9yPC90aXRsZT48ZyBkYXRhLW5hbWU9IlByb2R1Y3QgSWNvbnMiPjxnID48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE0LjczIiB5PSIxMS4yOCIgd2lkdGg9IjQuMTgiIGhlaWdodD0iMS4zOCIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTcuOTUiIHk9IjYuMTIiIHdpZHRoPSIxLjM4IiBoZWlnaHQ9IjExLjcxIi8+PHJlY3QgY2xhc3M9ImNscy0yIiB4PSIxNi4zIiB5PSIxNy4zMiIgd2lkdGg9IjQuNjgiIGhlaWdodD0iNC42OCIgcng9IjAuMjgiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjE2LjMiIHk9IjIiIHdpZHRoPSI0LjY4IiBoZWlnaHQ9IjQuNjgiIHJ4PSIwLjI4Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI2Ljk4IiB5PSIxMS4yOCIgd2lkdGg9IjQuMjgiIGhlaWdodD0iMS4zOCIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMy4wMyIgeT0iOS42MyIgd2lkdGg9IjQuNjgiIGhlaWdodD0iNC42OCIgcng9IjAuMjgiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xMywxNC4xN2EyLjIsMi4yLDAsMSwxLDIuMi0yLjJBMi4xOSwyLjE5LDAsMCwxLDEzLDE0LjE3Wm0wLTMuNTdBMS4zOCwxLjM4LDAsMSwwLDE0LjMzLDEyLDEuMzcsMS4zNywwLDAsMCwxMywxMC42WiIvPjwvZz48L2c+PC9zdmc+";
export { SvgVpn as ReactComponent };